import { render } from "./Gallery.vue?vue&type=template&id=6d6600a9"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
script.render = render

export default script